import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum EmergencyPrioritiesEnum {
    MissingTriageLevel = 0,
    HighPriority = 1,
    ModeratePriority = 2,
    LowPriority = 3
}
class EmergencyPrioritiesClass extends EnumWithDescription<EmergencyPrioritiesEnum> {
    public readonly enum = EmergencyPrioritiesEnum;
    public readonly enumName: string = "EmergencyPrioritiesEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<EmergencyPrioritiesEnum>> = new Map([
        [
            "MissingTriageLevel",
            {
                value: EmergencyPrioritiesEnum.MissingTriageLevel,
                name: "Missing Triage Level"
            }
        ],
        [
            "HighPriority",
            {
                value: EmergencyPrioritiesEnum.HighPriority,
                name: "Level I: High Priority"
            }
        ],
        [
            "ModeratePriority",
            {
                value: EmergencyPrioritiesEnum.ModeratePriority,
                name: "Level II: Moderate Priority"
            }
        ],
        [
            "LowPriority",
            {
                value: EmergencyPrioritiesEnum.LowPriority,
                name: "Level III: Low Priority"
            }
        ]
    ]);
}
export const EmergencyPriorities = new EmergencyPrioritiesClass();
